import { createSelectorPathBuilder } from '@/checkout-instore-legacy/utils/selectorHelper'
import compact from 'lodash/compact'
import isNil from 'lodash/isNil'
import {
  preprocessFilters,
  updateFiltersWithPreviousPriceFilter,
} from '@/checkout-instore-legacy/search/utils'

export const searchSelector = {
  this: (state) => state && state.search,
}

export const loadingProductsSelector = createSelectorPathBuilder(
  (state) => state.search.loadingSimulation
)

export const termSearchSelector = createSelectorPathBuilder(
  (state) => state.search.term
)

export const pageSearchSelector = createSelectorPathBuilder(
  (state) => state.search.page
)

export const resultsSearchSelector = createSelectorPathBuilder((state) => {
  const productsCache = state.product.products
  const searchProducts = compact(state.search.results)
  const hydratedProducts = searchProducts.map((product) => {
    const productCache = productsCache[product.id]
    if (isNil(productCache) || isNil(productCache.data)) {
      return product
    }
    return productCache.data
  })
  return compact(hydratedProducts)
})

export const nextResultsSearchSelector = createSelectorPathBuilder(
  (state) => state.search.nextResults
)

export const recentTermsSearchSelector = createSelectorPathBuilder(
  (state) => state.search.recentTerms
)

export const intervalBeginSearchSelector = createSelectorPathBuilder(
  (state) => state.search.intervalBegin
)

export const loadingSearchSelector = createSelectorPathBuilder(
  (state) => state.search.loading
)

export const errosSearchSelector = createSelectorPathBuilder(
  (state) => state.search.errors
)

export const nextLoadingSearchSelector = createSelectorPathBuilder(
  (state) => state.search.nextLoading
)

export const filtersSearchSelector = createSelectorPathBuilder(
  (state) => state.search.filters,
  (filters) => {
    const processedFilters = preprocessFilters(filters)
    return updateFiltersWithPreviousPriceFilter(processedFilters)
  }
)
